import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken, getUser, removeToken } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: () => import('@/views/Login.vue'), meta: { title: '登录' } },
  { path: '/register', name: 'Register', component: () => import('@/views/Register.vue'), meta: { title: '注册' } },
  { path: '/dashboard', name: 'Dashboard', component: () => import('@/views/Dashboard.vue'), meta: { title: '首页' } },
  { path: '/project', name: 'ProjectManage', component: () => import('@/views/ProjectManage.vue'), meta: { title: '维保项目管理' } },
  { path: '/orders', name: 'Orders', component: () => import('@/views/Orders.vue'), meta: { title: '工单管理' } },
  { path: '/personalDetails', name: 'PersonalDetails', component: () => import('@/views/PersonalDetails.vue'), meta: { title: '个人信息' } },
  { path: '/rights', name: 'UserRights', component: () => import('@/views/UserRights.vue'), meta: { title: '用户权益' } },
  { path: '/personnel', name: 'Personnel', component: () => import('@/views/Personnel.vue'), meta: { title: '人员管理' } },
  { path: '/inspection', name: 'Inspection', component: () => import('@/views/InspectionManage.vue'), meta: { title: '巡检管理' } },
  { path: '/inventory', name: 'Inventory', component: () => import('@/views/InventoryManage.vue'), meta: { title: '库存管理' } },
  { path: '/efficiency', name: 'EfficiencyReport', component: () => import('@/views/EfficiencyReport.vue'), meta: { title: '效率报告' } },
  { path: '/', redirect: '/dashboard' },
  { path: '*', redirect: '/dashboard' }
]

const router = new VueRouter({ mode: 'hash', routes })

const whiteList = ['/login', '/register']
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - Ai智慧电梯` : 'Ai智慧电梯维保平台'
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') { next({ path: '/' }) }
    else {
      const user = getUser()
      if (user) {
        const roleCodes = (user.roleCodes || []).map(c => (c || '').toUpperCase())
        const roleCode = (user.roleCode || '').toUpperCase()
        // 仅有 MAINT_USER 无 MAINT_ADMIN 不允许访问PC端（普通维保员不可查看）
        if (roleCodes.includes('MAINT_USER') && !roleCodes.includes('MAINT_ADMIN')) {
          removeToken()
          next('/login')
          return
        }
        // 允许访问维保端的角色：维保相关(MAINT*) / 平台管理员(SUPER_ADMIN/ADMIN) / 使用单位管理员(USAGE_ADMIN)
        const canAccessPc = roleCodes.some(c =>
          c.startsWith('MAINT') || c === 'SUPER_ADMIN' || c === 'ADMIN' || c === 'USAGE_ADMIN')
        if (!canAccessPc) {
          removeToken()
          next('/login')
          return
        }
        // 角色校验通过，放行
        next()
      } else {
        next()
      }
    }
  } else {
    whiteList.includes(to.path) ? next() : next('/login')
  }
})

export default router
